import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useSelector, shallowEqual, useDispatch } from "react-redux";

// import ReactLoading from 'react-loading'

import { categoryItemIsShowIsNotAvailable, escapeStringForJson, formatCurrency, netMerchantFee, origin } from '../../miscellaneous/helpers/utils';

import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

import { sendOrder } from "../../application/actions/cartActions";

import {
  BottomConfirm,
  BottomNav,
  CartDetailButton,
  BottomSpace,
  EmptyCart,
  // CartDetailButtonChoosePayment,
} from "../components/common";

import BackHomeTopNav from "../components/common/TopNav/BackHomeTopNav";

import { CartDetail } from "../";

import '../../App.css'

import { useDeliveryFeeCalculator, usePlatformFeeGenerator, useAdditionalFeeGenerator } from "../../application/hooks";
import { t } from "../../miscellaneous/language";
import { getMerchantDetails } from "../../application/actions/merchantActions";

import { LoadingComponent } from "../components/common/"
import useParkingFeeGenerator from "../../application/hooks/userParkingFeeGenerator";

const CartDetailContainer = () => {
  const dispatch = useDispatch();

  const store = useSelector(
    (state) => ({
      cart: state.cart,
      auth: state.auth,
      merchant: state.merchants.details,
    }),
    shallowEqual
  );  

  const [cartPrice, setCartPrice] = useState({
    totalPrice: 0,
    totalDiscount: 0,
  });

  const { deliveryFee } = useDeliveryFeeCalculator(
    store.cart.merchant?.lat,
    store.cart.merchant?.lon,
    store.cart.merchant?.name,
    store.auth.userData.lat,
    store.auth.userData.lon,
    store.auth.userData.addressName,
    store.auth.userData.host
  );


  // const additionalFee = 2000;
  const { additionalFee } = useAdditionalFeeGenerator(
    store.auth.userData.userID,
    store.auth.userData.name,
    store.auth.userData.lat,
    store.auth.userData.lon,
    store.auth.userData.city,
    store.auth.userData.host
  );  

  const { platformFee } = usePlatformFeeGenerator(
    store.auth.userData.userID,
    store.auth.userData.name,
    store.auth.userData.lat,
    store.auth.userData.lon,
    store.auth.userData.city,
    store.auth.userData.host
  );

  const { parkingFee } = useParkingFeeGenerator(
    store.auth.userData.userID,
    store.auth.userData.name,
    store.auth.userData.lat,
    store.auth.userData.lon,
    store.auth.userData.city,
    store.auth.userData.host
  );

  // const platformFee = null;
  const [orderNotes, setOrderNotes] = useState();
  const [orderedItems, setOrderedItems] = useState([]);

  const [isRequesting, setIsRequesting] = useState(false);
  const [loading, setLoading] = useState(false)

  const handleOrderNotes = (orderNotes) => {
    setOrderNotes(orderNotes);
  };

  const countCartSummary = () => {
    setCartPrice({
      totalPrice: 0,
      totalDiscount: 0,
    });
    // eslint-disable-next-line array-callback-return
    store.cart.items?.map((cartItem) => {
      setCartPrice((prevState) => ({
        ...prevState,
        totalPrice: prevState.totalPrice + (cartItem.total_with_addon ? cartItem.total_with_addon * cartItem.qty : cartItem.total * cartItem.qty),
      }));
      if (cartItem.discount) {
        setCartPrice((prevState) => ({
          ...prevState,
          totalDiscount:
            prevState.totalDiscount + cartItem.discount_amount * cartItem.qty,
        }));
      }
    });
  };

  const getMerchantServiceFee = (totalPrice, additionalPrice = []) => {
    if (!additionalPrice?.length) return 0;

    let result = 0;
    
    for (const [minPrice, price] of additionalPrice) {
      if (totalPrice >= minPrice) {
        result = price;
      } else {
        break;
      }
    }


    return result;
  };

  //  console.log(store.cart)
  React.useEffect(() => {
    countCartSummary();
    prepareOrderedItems();
    if (store?.cart?.items?.length === 0) setLoading(false)
    // console.log(deliveryFee);
  }, [store, orderedItems, deliveryFee]);

  React.useEffect(() => {
    if (loading) {
      document.body.style.overflow = 'hidden';
      return () => document.body.style.overflow = 'unset';
    }
  }, [loading]);

  const prepareOrderedItems = () => {
    let itemsArray = [];

    // eslint-disable-next-line array-callback-return
    store.cart.items?.map((cartItem) => {
      let tempArray;
      if (cartItem.orderDesc === null) {
        tempArray = {
          item_id: cartItem.id,
          quantity: cartItem.qty,
          price: cartItem.price,
          discount: cartItem.discount,
          discount_amount: cartItem.discount_amount,
          total: cartItem.total * cartItem.qty,
        };
      } else {
        tempArray = {
          item_id: cartItem.id,
          quantity: cartItem.qty,
          price: cartItem.price,
          discount: cartItem.discount,
          discount_amount: cartItem.discount_amount,
          notes: cartItem.orderDesc,
          total: cartItem.total * cartItem.qty,
        };
      }
      if (cartItem.addonChoosed) {
        tempArray['addonChoosed'] = cartItem.addonChoosed
      }

      itemsArray.push(tempArray);
    });

    if (JSON.stringify(itemsArray) !== JSON.stringify(orderedItems)) {
      setOrderedItems(itemsArray);
    }
  };

  const showAlert = ({ title = t.alert.alert, message, buttonText = t.btn.alertOk, buttonClassName = "info-button" }) => {
    confirmAlert({
      customUI: ({ onClose }) => (
        <div className="alert">
          <h1>{title}</h1>
          <p>{message}</p>
          <div className="alert-button-container">
            <button className={buttonClassName} onClick={onClose}>
              {buttonText}
            </button>
          </div>
        </div>
      ),
    });
  };

  const trySendOrder = () => {
    if (store.auth.userData.lat === 0 || store.auth.userData.lon === 0) {
      showAlert({ message: t.alert.noteDeliveryPrice });
      return;
    }    

    if (store.merchant?.is_closed === 1) {
      alert(t.alert.merchantClose);
      return;
    }

    if (deliveryFee?.data?.result?.Price == null) {
      showAlert({ message: t.alert.noteCountDeliveryPrice });
      return;
    }

    if (platformFee == null) {
      showAlert({ message: t.alert.notePlatformPrice });
      return;
    }

    if (isRequesting) {
      showAlert({ message: t.alert.noteProcessOrder });
      return;
    }

    if (store.cart.items.some((item) => categoryItemIsShowIsNotAvailable({ category: item.item_category }))) {
      showAlert({
        message: "one or more item in cart is not available, to continue please remove the unavailable item",
      });
      return;
    }

    if(origin == 'id' && cartPrice.totalPrice < 10000){
      showAlert({ message: t.alert.noteMinOrder });
      return;
    }

    confirmAlert({
      customUI: ({ onClose }) => (
        <div className="alert">
          <h1>{t.alert.confirmOrder}</h1>
          <p>{t.alert.noteConfirmOrder}</p>
          <div className="alert-button-container">
            <button
              className="yes-button"
              onClick={() => {
                dispatch(
                  sendOrder(
                    store.auth.userData.userID,
                    store.auth.userData.lat,
                    store.auth.userData.lon,
                    store.auth.userData.city,
                    store.auth.userData.host,
                    store.auth.userData.name,
                    store.auth.userData.addressName,
                    store.cart.items?.length,
                    cartPrice.totalPrice,
                    cartPrice.totalDiscount,
                    deliveryFee?.data.result.Price,
                    cartPrice.totalPrice + deliveryFee?.data.result.Price + netMerchantFee(getMerchantServiceFee(cartPrice.totalPrice, additionalFee?.merchant_fee), additionalFee?.aist_m_fee),
                    orderNotes,
                    store.cart.merchant?.id,
                    orderedItems,
                    platformFee,
                    parkingFee,
                    store.cart.merchant.takeaway_charge,
                    getMerchantServiceFee(cartPrice.totalPrice, additionalFee?.merchant_fee)
                  )
                );
                setIsRequesting(true);
                setLoading(true);
                onClose();
              }}>
              {t.btn.yes}
            </button>
            <button className="no-button" onClick={onClose}>
              {t.btn.no}
            </button>
          </div>
        </div>
      ),
    });
  };

  React.useEffect(() => {
    if (store.cart.merchant?.id) {
      dispatch(getMerchantDetails(store.cart.merchant?.id));
    }
  }, [])

  return (
    <>
      <div className="wrapper-gray">
        <Helmet>
          <title>{t.helmet.title.DetailCart}</title>
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <meta name="description" content={t.helmet.desc.DetailCart} />
        </Helmet>
        {store.cart.items?.length === 0 ? (
          <>
            <EmptyCart />
            <BottomNav />
          </>
        ) :
          (
            <>
              <BackHomeTopNav
                image={store.cart.merchant?.image}
                title={store.cart.merchant?.name || t.helmet.title.DetailCart}
                backTo={store.cart.merchant?.id ? `/merchant/${store.cart.merchant.id}` : '/home'}
              />
              <CartDetail
                cart={store.cart}
                handleOrderNotes={handleOrderNotes}
                deliveryFee={deliveryFee}
                merchantFee={getMerchantServiceFee(cartPrice.totalPrice, additionalFee?.merchant_fee)}
                aistFee={additionalFee?.aist_m_fee ?? 0}
                totalPrice={cartPrice.totalPrice}
                totalDiscount={cartPrice.totalDiscount}
                platformFee={platformFee}
                parkingFee={parkingFee}
                merchant={store.merchant}
              />
              {/* {store.auth.userData?.addressName && (
                <div className="cart-detail-address-warning">
                  <p>{store.auth.userData?.addressName}</p>
                </div>
              )} */}
              {/* <CartDetailButton orderFunction={trySendOrder} /> */}
              <BottomSpace class="gray-bottom-space" />
            </>
          )
        }
        {loading
          &&
          <LoadingComponent />
        }
      </div>
      {store.cart.items?.length !== 0 &&
        <>
          <BottomConfirm
            deliveryFee={deliveryFee}
            totalPrice={cartPrice.totalPrice}
            totalDiscount={cartPrice.totalDiscount}
            platformFee={platformFee}
            takeaway_charge={store.cart?.merchant?.takeaway_charge}
            additionalFee={getMerchantServiceFee(cartPrice.totalPrice, additionalFee?.merchant_fee)}
            aistFee={additionalFee?.aist_m_fee ?? 0}
            // total={formatCurrency((cartPrice.totalPrice + (deliveryFee?.data?.result?.Price ? deliveryFee?.data?.result?.Price : 0) + platformFee))}
            orderFunction={trySendOrder}
            parkingFee={parkingFee}
          />
          <BottomNav />
        </>
      }
    </>
  );
};

export default CartDetailContainer;
